import React from "react";
import { cx } from "../utils";

/**
 * CcToolFormOption — single selectable row in a tool form section.
 */
const CcToolFormOption = ({
  label,
  score,
  selected = false,
  multiple = false,
  disabled = false,
  name,
  value,
  onChange,
  className,
}) => {
  const inputType = multiple ? "checkbox" : "radio";

  return (
    <label
      className={cx(
        "cc-tool-form-option",
        selected && "is-selected",
        disabled && "is-disabled",
        className,
      )}
    >
      <input
        type={inputType}
        className="cc-tool-form-option__input"
        name={name}
        value={value}
        checked={selected}
        disabled={disabled}
        onChange={onChange}
      />
      <span className="cc-tool-form-option__leading">
        <span className="cc-tool-form-option__control" aria-hidden />
        <span className="cc-tool-form-option__label">{label}</span>
      </span>
      {typeof score === "number" ? (
        <span
          className="cc-tool-form-option__score"
          aria-label={`Score ${score}`}
        >
          {score}
        </span>
      ) : null}
    </label>
  );
};

export default CcToolFormOption;
